
import EZUIKit from "ezuikit-js";
export default {
  created() {

    let t = this;

    axios.post('rlock/getCameraAccessToken').then(res => {
      if (res.data.status == 1) {
        setTimeout(() => {
          const UIKitDEMO = new EZUIKit.EZUIKitPlayer({
            id: "ezuikit-player",
            url: "ezopen://open.ys7.com/BF5088817/1.hd.live",
            accessToken: res.data.options.access_token
          });
        }, 100);
      }
    });


  },
  activated() {
  },
  methods: {
    loadData() {
      let t = this;

    },
    closeCase() {
      axios.post('rlock/open').then(res => {
        if (res.data.status == 1) {
          A.show('施法成功！快去解救它吧！', '已关闭', 'success');
        }
      });

    }
  },
  data() {
    return {
      view: "",
      errMsg: "",
      busying: false,
      list: {
      }
    };
  },
};
